<template>
  <div>
    <div class="text-primary text-subtitle2 text-uppercase q-mb-sm">
      Daily Reminders
    </div>
    <div class="row">
      <div class="col-7">
      <span v-if="request.remindersEnabled">
        The client is receiving daily reminders to import their
        {{ platform }} posts.
      </span>
        <span v-else>
        The client is not receiving daily reminders to import their
        {{ platform }} posts.
      </span>
      </div>
      <div class="col text-right">
        <toggle-reminders-btn
          :request="request"
          @update:request="$emit('update:request', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReconnectRequest } from '@/social/types';
import ToggleRemindersBtn from './ToggleRemindersBtn.vue';

export default defineComponent({
  emits: ['update:request'],
  components: { ToggleRemindersBtn },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
});
</script>
